import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalText,
  AcceptButton,
} from "./LegalDisclaimerModal.styled";

const LegalDisclaimerModal = ({ onAccept, show }) => {
  if (!show) {
    return null;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Ważne Ostrzeżenie</ModalHeader>
        <ModalText>
          <strong>Asystent Prawny</strong> to narzędzie wspomagające, które nie zastępuje profesjonalnej porady prawnej.
        </ModalText>
        <ModalText>
          Informacje i odpowiedzi generowane przez tego asystenta <strong>nie stanowią prawnie wiążącej porady prawnej</strong> i nie mogą być traktowane jako oficjalna opinia prawna.
        </ModalText>
        <AcceptButton onClick={onAccept}>
          Rozumiem i akceptuję
        </AcceptButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default LegalDisclaimerModal;

